import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Hamburger from "hamburger-react";

import AppMobileMenu from "./AppMobileMenu";
import {
  setEnableClosedSidebar,
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
} from "../../../reducers/ThemeOptions";

// import type { RootState, AppDispatch } from "../../../store";

const avtImg = "/images/logo_benhvien_108.png";

type RootState = {
  ThemeOptions: {
    enableClosedSidebar: boolean;
    enableMobileMenu: boolean;
    enableMobileMenuSmall: boolean;
  };
};

// Nếu có AppDispatch riêng thì dùng:
// const dispatch = useDispatch<AppDispatch>();
const HeaderLogo: React.FC = () => {
  const dispatch = useDispatch();

  const enableClosedSidebar = useSelector(
    (state: RootState) => state.ThemeOptions.enableClosedSidebar
  );

  const handleToggleClosedSidebar = () => {
    dispatch(setEnableClosedSidebar(!enableClosedSidebar));
  };

  useEffect(() => {
    localStorage.setItem("enableSidebar", JSON.stringify(!enableClosedSidebar));
  }, [enableClosedSidebar]);

  return (
    <>
      <div className="app-header__logo">
        <img
          width={42}
          className={`rounded-circle ${enableClosedSidebar ? "hidden" : ""}`}
          src={avtImg}
          alt="BV108 logo"
        />

        <div className="header__pane ms-auto">
          <div onClick={handleToggleClosedSidebar}>
            <Hamburger
              toggled={enableClosedSidebar}
              toggle={handleToggleClosedSidebar}
              size={26}
              color="#eaeaeaff"
            />
          </div>
        </div>
      </div>

      <AppMobileMenu />
    </>
  );
};

export default HeaderLogo;
